module.exports = __webpack_public_path__ + "static/img/slider-rev4.aea6fb5e.jpg";